export const routesPymRoutes = (apiBase) => ({
  getTemplateObs: (activity) => `${apiBase}/templates?codigo=${activity}`,
  getRPYM: (Subgrupo, Cons) => `${apiBase}/pym-routes?idSubgrupo=${Subgrupo}&idCons=${Cons}`,
  getRPYMById: (id) => `${apiBase}/pym-routes?id=${id}`,
  saveRoutesPYM: `${apiBase}/pym-routes`,
  getRoutes: `${apiBase}/routes`,
  getRoutesById: (id) => `${apiBase}/routes-by-id?id=${id}`,
  saveRoute: `${apiBase}/routes`,
  getGroups: (idruta) => `${apiBase}/groups?ruta=${idruta}`,
  getGroupsById: (id) => `${apiBase}/groups-by-id?id=${id}`,
  saveGroup: `${apiBase}/groups`,
  getSubGroups: (subgrupo, grupo) => `${apiBase}/subgroups?subgrupo=${subgrupo}&grupo=${grupo}`,
  saveSubGroup: `${apiBase}/subgroups`,
  getActiveGroups: (tipoId, ident) => `${apiBase}/subgroups-menus?tipo_id=${tipoId}&num_id=${ident}`,
  postActiveGroups: `${apiBase}/subgroups-menus`,
  getCumplimientoRutaMaterna: (autoid) => `${apiBase}/ruta-materna/cumplimiento?autoid=${encodeURIComponent(autoid || "")}`,
});
